export const RARITIES = [1,2,3,4,5];
export const ATTRIBUTES = {
	'1': 'Speed',
	'2': 'Power',
	'3': 'Technique'
};
export const PART_TYPES = {
	'1': 'Head',
	'2': 'Chest',
	'3': 'Arms',
	'4': 'Legs',
	'5': 'Backpack',
	'6': 'Shield',
	'Pilot': {
		'8': 'Defender',
		'13': 'Supporter',
		'7': 'All-Rounder',
		'9': 'In-Fighter',
		'10': 'Out-Fighter',
		'11': 'Middle-Shooter',
		'12': 'Long-Shooter',
	},
	'Melee': {
		'14': 'Axe',
		'15': 'Saber',
		'16': 'Fist Module',
		'17': 'Claw Module',
		'18': 'Blade',
		'19': 'Lance',
		'20': 'Dual Saber',
		'26': 'Whip',
		'29': 'Twin Blade',
	},
	'Ranged': {
		'21': 'Rifle',
		'22': 'Machinegun',
		'23': 'Long Rifle',
		'24': 'Gatling Gun',
		'25': 'Bazooka',
		'27': 'Unknown',
	},
};
export const STATS = {
	'armor': 'Armor',
	'atk_melee': 'Melee ATK',
	'atk_shot': 'Shot ATK',
	'def_melee': 'Melee DEF',
	'def_shot': 'Shot DEF',
	'res_beam': 'Beam RES',
	'res_phys': 'Phys RES',
};
export const SKILL_TYPES = [
	'Physical Shot',
	'Physical Melee',
	'Beam Shot',
	'Beam Melee',
	'Buff',
	'Debuff',
	'Recovery',
	'Awakening',
];
export const SKILL_RATINGS = [
	'-',
	'A-', 'A', 'A+',
	'B-', 'B', 'B+',
	'C-', 'C', 'C+',
	'D-', 'D', 'D+',
];
export const SKILL_INFO = {
	'Type': 'skill_type',
	'Pierce': 'skill_pierce',
	'Power': 'skill_power',
	'Magazine': 'skill_magazine',
	'Recovery': 'skill_recovery',
	'Effect Time': 'skill_effect_time',
	'Cooldown': 'skill_cooldown'
};
export const SKILL_MAGAZINES = [0,4,7,9,11];
export const SKILL_EFFECT_TIMES = ['1s', '27s','37s','44s','51s'];
export const SKILL_RECOVERIES = ['38%','48%'];
export const SKILL_COOLDOWNS = ['79s','73s','60s','44s','41s','40s','44s','35s','33s','30s','25s','21s','19s','12s'];
export const SKILL_COOLDOWNS_FIRST = ['0s','2s','3s','4s','5s','6s','7s','8s','9s','11s','12s','15s','19s','20s','35s'];

